import { useContext } from 'react';
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'


export interface Props {
    className?: string
    precio_lista?: number,
    activeClass?: string;
    style?: React.CSSProperties
}

const currencyFormatter = (currency: string, value: number) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        minimumFractionDigits: 2,
        currency
    })
    return formatter.format(value)
}

let dollar: string = ""

export const ProductPrecio = ({ precio_lista, className, style }: Props) => {

    const { product } = useContext(ProductContext)
    return (
        <span
            className={`${styles.productDescription} ${className}`}
            style={style}
        >

            {precio_lista ? dollar = currencyFormatter(
                "USD",
                Number(precio_lista)
            ) + " USD" : dollar = currencyFormatter(
                "USD",
                Number(product.precio_lista)
            ) + " USD"}
        </span>
    );
}